const Loader = () => {
  return (
    <>
      <div className="preloader">
        <div className="loder"></div>
        <div className="loader-logo">
          <img
            src="assets/images/logo/logo.png"
            alt="img"
            className="img-fluid"
          />
        </div>
      </div>
    </>
  );
};

export default Loader;
